export default {
  'Choose File': '选择文件',
  'Please paste a URL': '输入一个视频URL链接',
  'Loading': '加载中',
  'Analyzing': '获取中',
  'Try a sample': '试一试示例',
  'Sorry, error occurs when analyzing the URL.': '抱歉，URL解析出错了。',
}